import React from "react";
import * as Icon from "react-feather";
let navigationConfig = [
  // {
  //   type: "item",
  //   title: "Dashboard",
  //   navLink: "/dashboard",
  //   icon: <Icon.Layout size={20} />,
  // },
  {
    type: "item",
    title: "Add New Inbound",
    navLink: "/new-loading-dock",
    icon: <Icon.Layers size={20} />,
  },
  {
    type: "item",
    title: "Add New Outbound",
    navLink: "/new-out-inventories",
    icon: <Icon.Layers size={20} />,
  },
  {
    type: "item",
    title: "Loading Dock",
    navLink: "/loading-dock-history",
    icon: <Icon.LogIn size={20} />,
  },
  {
    type: "item",
    title: "Out Inventory",
    navLink: "/out-inventories",
    icon: <Icon.LogOut size={20} />,
  },
  {
    type: "Reports",
    title: "Reports",
    navLink: "/reports",
    icon: <Icon.Triangle size={20} />
  },
  {
    type: "subMenu",
    icon: <Icon.MoreVertical size={20} />,
    title: "More",
    childrens: [{
      type: "item",
      title: "Main Catalogue",
      navLink: "/catalogue",
      icon: <Icon.List size={20} />,
    },
    {
      type: "item",
      title: "Suppliers",
      navLink: "/suppliers",
      icon: <Icon.User size={20} />,
    },
    {
      type: "item",
      title: "Partner organizations",
      navLink: "/clients",
      icon: <Icon.User size={20} />,
    },
    {
      type: "item",
      title: "Queues",
      navLink: "/queue",
      icon: <Icon.GitPullRequest size={20} />,
    },
    {
      type: "item",
      title: "Programs",
      navLink: "/programs",
      icon: <Icon.Activity size={20} />,
    },
    {
      type: "item",
      title: "Warehouse",
      navLink: "/warehouse",
      icon: <Icon.Layers size={20} />,
    },
    {
      type: "item",
      title: "Locations",
      navLink: "/locations",
      icon: <Icon.Map size={20} />,
    }]},
]

export default navigationConfig;
